import React, { useState, useEffect } from 'react';
import PlantForm from './PlantForm';
import PlantCard from './PlantCard';
import './Plants.css';

const Plants = ({ user }) => {
  const [plants, setPlants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    fetchPlants();
  }, []);

  const fetchPlants = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/plants.php`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      const data = await response.json();
      if (data.success) {
        setPlants(data.data || []);
      } else {
        setError('Failed to fetch plants');
      }
    } catch (err) {
      setError('Error connecting to server');
      console.error('Error fetching plants:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleAddPlant = () => {
    setShowForm(true);
  };

  const handleFormClose = (added) => {
    setShowForm(false);
    if (added) {
      setSuccess('Plant added successfully!');
      setTimeout(() => setSuccess(''), 3000);
      fetchPlants();
    }
  };

  const handlePlantUpdate = () => fetchPlants();

  const handleDeletePlant = async (plantId) => {
    if (!window.confirm('Delete this plant?')) return;

    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/plants.php?id=${plantId}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });

      const data = await res.json();
      if (data.success) {
        setSuccess('Plant deleted successfully!');
        setTimeout(() => setSuccess(''), 3000);
        fetchPlants();
      } else {
        setError(data.message || 'Delete failed');
      }
    } catch (err) {
      setError('Error deleting plant');
      console.error(err);
    }
  };

  const filteredPlants = plants.filter(p =>
    p.plant_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    p.address?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    p.contact_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="plants-container">
      <div className="plants-header">
        <div>
          <h1>Plant Management</h1>
          <p className="page-subtitle">Manage plants, depots & factories and their contact details</p>
        </div>
        <div className="header-actions">
          <button className="btn-primary" onClick={handleAddPlant}>
            <span>+</span> Add Plant
          </button>
        </div>
      </div>

      {error && (
        <div className="alert alert-danger">
          <span>❌</span> {error}
        </div>
      )}

      {success && (
        <div className="alert alert-success">
          <span>✅</span> {success}
        </div>
      )}

      <div className="filters-section">
        <div className="search-box">
          <input
            type="text"
            placeholder="🔍 Search by name, address, contact person..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>
      </div>

      {loading ? (
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <p>Loading plants...</p>
        </div>
      ) : filteredPlants.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">📍</div>
          <h3>No plants found</h3>
          <p>{searchTerm ? 'Try different search terms' : 'Add your first plant to get started'}</p>
          {!searchTerm && (
            <button className="btn-primary" onClick={handleAddPlant}>
              Add First Plant
            </button>
          )}
        </div>
      ) : (
        <div className="plants-grid">
          {filteredPlants.map(plant => (
           <PlantCard
                key={plant.id}
                plant={plant}
                onUpdate={handlePlantUpdate}
                onDelete={handleDeletePlant}
                userRole={user?.role}
                />
          ))}
        </div>
      )}

      {showForm && (
        <div className="modal-overlay">
          <div className="modal">
            <PlantForm onClose={handleFormClose} />
          </div>
        </div>
      )}
    </div>
  );
};

export default Plants;